// extracted by mini-css-extract-plugin
module.exports = {"img":"previewPicture_img_G9ItA","img-head":"previewPicture_img-head_2Hx3v","bg":"previewPicture_bg_3yZw4"};